export default [
  {
    categoryTitle: 'Management',
    id: 1,
    order: 1,
    items: [
      {
        id: 11,
        title: 'Dashboard',
        category: { id: 1 },
        routeRegex: /\/admin\/dashboard\/*/,
        route: '/admin/dashboard'
      },
      {
        id: 12,
        title: 'Applications',
        category: { id: 1 },
        routeRegex: /\/admin\/all-applications\/*/,
        route: '/admin/all-applications'
      },
      {
        id: 13,
        title: 'Pending Reviews',
        category: { id: 1 },
        routeRegex: /\/admin\/pending-reviews\/*/,
        route: '/admin/pending-reviews'
      }
    ]
  },
]